import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { Toggle } from './Toggle';
import { SmartInput } from './SmartInput';

interface SpawnerSettingsSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const SpawnerSettingsSection: React.FC<SpawnerSettingsSectionProps> = ({ config, setConfig }) => (
  <div className="w-full flex flex-col gap-3 p-4 rounded-3xl border bg-orange-500/5 border-orange-500/10 mb-4">
    <SectionLabel icon="fa-plus-circle" darkMode={config.darkMode}>Spawner Variables</SectionLabel>
    <div className="grid grid-cols-2 gap-3">
      <div className="flex items-center justify-between border border-white/5 p-2 rounded-xl">
        <span className="text-[10px] font-black uppercase opacity-60">Wall Spawn</span>
        <Toggle active={config.spawnOnWallCollision} onClick={() => setConfig(p => ({...p, spawnOnWallCollision: !p.spawnOnWallCollision}))} />
      </div>
      <div className="flex items-center justify-between border border-white/5 p-2 rounded-xl">
        <span className="text-[10px] font-black uppercase opacity-60">Ball Spawn</span>
        <Toggle active={config.spawnOnBallCollision} onClick={() => setConfig(p => ({...p, spawnOnBallCollision: !p.spawnOnBallCollision}))} />
      </div>
    </div>
    <SmartInput label="Initial Balls" min={1} max={50} value={config.initialBalls} onChange={v => setConfig(p => ({...p, initialBalls: v}))} darkMode={config.darkMode} />
    <SmartInput label="Max Balls" min={10} max={1000} value={config.maxBalls} onChange={v => setConfig(p => ({...p, maxBalls: v}))} darkMode={config.darkMode} />
  </div>
);